export const rankItemTheme = {
  colorOne: "#E0F9F2",
  colorTwo: "#eddcff",
  colorThree: "rgb(173, 56, 173)",
};

export const progressTheme = {
  colorOne: "#f0bbdb",
  colorTwo: "#eddcff",
  colorThree: "rgb(173, 56, 173)",
};

export const rankOneTheme = {
  colorOne: "gold",
  colorTwo: "white",
  colorThree: "gold",
};

//#f33aa9, #eddcff, rgb(173, 56, 173)
